"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The TouModel model module.
 * @module model/TouModel
 * @version 1.1.3-alpha.1
 */
class TouModel {
  /**
   * Constructs a new <code>TouModel</code>.
   * @alias module:model/TouModel
   * @param id {String} 
   * @param content {String} 
   */
  constructor(id, content) {
    TouModel.initialize(this, id, content);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, id, content) {
    obj['id'] = id;
    obj['content'] = content;
  }

  /**
   * Constructs a <code>TouModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TouModel} obj Optional instance to populate.
   * @return {module:model/TouModel} The populated <code>TouModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TouModel();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('content')) {
        obj['content'] = _ApiClient.default.convertToType(data['content'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>TouModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TouModel</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of TouModel.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
      throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
    }
    return true;
  }
}
TouModel.RequiredProperties = ["id", "content"];

/**
 * @member {String} id
 */
TouModel.prototype['id'] = undefined;

/**
 * @member {String} content
 */
TouModel.prototype['content'] = undefined;
var _default = exports.default = TouModel;